import * as React from 'react'

function IconPhoto(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={165}
      height={164}
      viewBox="0 0 165 164"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M164.15 81.81C164.15 36.628 127.522 0 82.34 0S.53 36.628.53 81.81s36.628 81.81 81.81 81.81 81.81-36.628 81.81-81.81z"
        fill="#F4BA27"
      />
      <path
        d="M130.13 102.03a9.708 9.708 0 01-9.54 9.49 6.94 6.94 0 01-.79 0 6.19 6.19 0 00-5.92 3.15c-7 12.71-20.34 19-33.44 18.76-13.23-.63-26.24-7.89-32.35-21.29a5.373 5.373 0 00-5.12-3.13h-.51a9.711 9.711 0 01-9.61-9.35 9.64 9.64 0 019.94-9.89 1.88 1.88 0 002-1.68C47.48 60.6 65.57 47.16 83.21 47.6c17.61.7 34.78 15.26 35.71 42.83a1.933 1.933 0 001.88 1.86 9.63 9.63 0 019.33 9.74z"
        fill="#fff"
      />
      <path
        d="M117.22 100.55a.706.706 0 01-.52-.26.7.7 0 01-.161-.524.679.679 0 01.271-.476c.16-.13 3.93-3 10.06-1.41a.683.683 0 01.509.572.695.695 0 01-.859.758c-5.44-1.45-8.72 1-8.86 1.15a.672.672 0 01-.44.19z"
        fill="#000"
      />
      <path
        d="M125.51 102.62a.672.672 0 01-.55-.32 6.994 6.994 0 00-4.68-3.15.689.689 0 01-.462-.248.683.683 0 01-.07-.758.669.669 0 01.406-.33.68.68 0 01.266-.024 8.267 8.267 0 015.69 3.77.698.698 0 01.116.546.678.678 0 01-.326.454.699.699 0 01-.39.06zM46.82 98.28a.74.74 0 01-.44-.18c-.13-.12-3.24-2.82-8.76-1.73a.682.682 0 01-.707-1.052.68.68 0 01.437-.288c6.24-1.24 9.8 1.92 10 2a.68.68 0 010 1 .679.679 0 01-.53.25z"
        fill="#000"
      />
      <path
        d="M38.41 99.8a.67.67 0 01-.38-.13.692.692 0 01-.15-1 8.32 8.32 0 015.92-3.4.69.69 0 01.539 1.153.682.682 0 01-.48.217 6.92 6.92 0 00-4.869 2.84.68.68 0 01-.58.32zM82.48 106.45a.682.682 0 01-.63-.49.679.679 0 01.45-.85c5.41-1.64 5.78-2.54 5.8-2.71.05-.37-1.28-1.15-2.07-1.62a9.145 9.145 0 01-3.26-2.63c-1.95-3.28-.63-15.35-.47-16.72a.68.68 0 01.76-.6.67.67 0 01.6.76c-.41 3.58-1.16 13.42.29 15.85a8.449 8.449 0 002.77 2.16c1.49.88 2.9 1.71 2.74 3-.16 1.29-1.33 2.2-6.76 3.85a.81.81 0 01-.22 0zM84.41 112.34a7.998 7.998 0 01-8-6.67.69.69 0 01.6-.76.688.688 0 01.76.59c0 .23.78 5.43 6.92 5.47a.729.729 0 01.68.7.702.702 0 01-.69.68l-.27-.01zM102.779 96.975c.061-1.887-.762-3.446-1.838-3.48-1.077-.036-1.999 1.467-2.06 3.355-.06 1.887.762 3.446 1.839 3.481 1.076.034 1.998-1.468 2.059-3.356zM66.85 95.82c.06-1.889-.763-3.447-1.84-3.482-1.076-.035-1.998 1.468-2.059 3.355-.06 1.888.763 3.447 1.839 3.481 1.076.035 1.998-1.467 2.06-3.355z"
        fill="#000"
      />
      <path
        d="M42.79 89.75S23.32 86.92 27.06 70c3.74-16.92 9.84-14.86 13.92-25.21 4.08-10.35 21-18.81 39.33-11.47 18.33 7.34 31.6-6.85 43.86-2.14 12.26 4.71 2.16 14.49 4.1 18.86 1.94 4.37 9.9 7.06 7.33 17.09-2.57 10.03-8.1 27.22-15.72 24.87-6.43-2-5.43-27.22-15.95-31.12-9.65-3.58-24.09 10.48-41.78 4a3.91 3.91 0 00-5.23 3.28c-.86 8.03-3.84 21.9-14.13 21.59z"
        fill="#E84E25"
      />
      <path
        d="M57.92 87.37a.79.79 0 01-.33-.1.68.68 0 01-.24-.94c0-.08 5.14-8.43 14.25-5.86a.7.7 0 01.47.85.69.69 0 01-.85.47c-8.1-2.29-12.65 5.16-12.69 5.24a.71.71 0 01-.61.34zM108.78 88.67a.697.697 0 01-.59-.38c-.17-.32-4.12-7.81-12.33-6a.7.7 0 01-.82-.53.69.69 0 01.53-.81c9.25-2 13.79 6.67 13.84 6.76a.68.68 0 01-.3.92.669.669 0 01-.33.04z"
        fill="#000"
      />
      <path
        d="M64.64 110.062c5.18-.904 9.083-3.331 8.719-5.42-.365-2.089-4.86-3.05-10.039-2.146-5.18.904-9.083 3.33-8.718 5.42.365 2.089 4.86 3.05 10.039 2.146zM110.017 110.008c.581-2.04-3.047-4.861-8.103-6.301-5.057-1.441-9.627-.955-10.208 1.085-.581 2.04 3.047 4.861 8.104 6.301 5.056 1.44 9.626.955 10.207-1.085z"
        fill="#FFDEDE"
      />
    </svg>
  )
}

export default IconPhoto
